import getActiveApplications from 'core/services/getActiveApplications'
import store from 'utils/store/withMiddleware'
function getAdditionalInfo(state) {
  return getActiveApplications(state).then(data => {
    const { data: activeApplications } = data

    const hasDentalActive = activeApplications.some(
      app => app.productType && app.productType.toLowerCase() === 'dental' && app.active
    )
    const hasVisionActive = activeApplications.some(
      app => app.productType && app.productType.toLowerCase() === 'vision' && app.active
    )

    store.update(
      {
        hasDentalActive,
        hasVisionActive
      },
      true
    )
    return store.getState()
  })
}

export default getAdditionalInfo
